// Shared React vendor bundle. Built once and loaded before every island bundle,
// so React + ReactDOM ship ONCE app-wide instead of being duplicated into each
// island's IIFE (~140 KB each). The island builds externalize react/react-dom/
// react-dom/client/react-jsx-runtime onto the globals assigned below (see
// vite.config.js REACT_GLOBALS). Future React bumps happen in one place.
import React from 'react';
import ReactDOM from 'react-dom';
import * as ReactDOMClient from 'react-dom/client';
import * as ReactJsxRuntime from 'react/jsx-runtime';

window.React = React;                 // default export = the React object (createElement, hooks, …)
window.ReactDOM = ReactDOM;           // render / createPortal / flushSync …
window.ReactDOMClient = ReactDOMClient; // createRoot / hydrateRoot
window.ReactJsxRuntime = ReactJsxRuntime; // jsx / jsxs / Fragment (automatic JSX runtime)
